import type { Conversation } from "./api";

export type GroupKey = "pinned" | "today" | "yesterday" | "week" | "older";

/** Groups conversations (already sorted) into sidebar sections by recency. */
export function groupConversations(
  items: Conversation[],
  now = Date.now(),
): Array<{ key: GroupKey; items: Conversation[] }> {
  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  const day = 86_400_000;
  const buckets: Record<GroupKey, Conversation[]> = {
    pinned: [],
    today: [],
    yesterday: [],
    week: [],
    older: [],
  };
  for (const c of items) {
    if (c.pinned) buckets.pinned.push(c);
    else if (c.updatedAt >= startOfToday.getTime()) buckets.today.push(c);
    else if (c.updatedAt >= startOfToday.getTime() - day) buckets.yesterday.push(c);
    else if (c.updatedAt >= startOfToday.getTime() - 7 * day) buckets.week.push(c);
    else buckets.older.push(c);
  }
  return (Object.keys(buckets) as GroupKey[])
    .filter((k) => buckets[k].length)
    .map((key) => ({ key, items: buckets[key] }));
}
